<template lang="pug">
    .container(ref='container')
        .animated-scroll(
            ref='animatedScroll', 
            )
            .masked-text(v-if='content')
                .content(ref='content')
                    .section-block(
                        v-for='block in content',
                        :class='[block.position, block.modifier]'
                        )

                        .texts(v-if='block.type === "text"')

                            .texts__wrap(v-if='Array.isArray(block.textblocks)' v-html='block.textblocks.join("")')

                            .texts__side-illustration(v-if='block.quote')
                                .quote(
                                    v-if='block.quote'
                                    )
                                    .quote__content(v-html='block.quote')
                .masked-text__mask-wrp
                    .masked-text__mask
                        .mask-aim(ref='mask')
                            .bg-holder.top
                            .bg-holder.right
                            .bg-holder.bottom
                            .bg-holder.left
                            img(src='../../assets/img/text-appearing/aim.svg')
</template>
<script>
import {gsap, MotionPathPlugin} from 'gsap/all';
import {mixinAnimation} from '../mixins/animatedScreen';
gsap.registerPlugin(MotionPathPlugin);

export default {
    props: {
        content: {
            type: Array
        },
        settings: Object,
        isActive: Boolean
    },
    data() {
        return {
            bScrollInst: null,
            timeline: null,
            isInited: false,
            innerBlockPosition: 'top'
        };
    },
    mixins: [mixinAnimation],
    methods: {
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            this.timeline
                .set(this.$refs.content, {filter: 'blur(20px)', webkitFilter: 'blur(20px)'})
                .set(this.$refs.mask, {x: '60vw', y: '-60vh', opacity: '1', scale: '1'})
                .to(this.$refs.content, {duration: 3, filter: 'blur(0px)', webkitFilter: 'blur(0px)'}, 0)
                .to(
                    this.$refs.mask,
                    {
                        keyframes: [
                            {x: -100, y: -150},
                            {x: -90, y: 150},
                            {x: 58, y: 80},
                            {x: 40, y: -40},
                            {x: -20, y: 20},
                            {x: 0, y: 0}
                        ],
                        duration: 3,
                        ease: 'power2.inOut'
                    },
                    0
                )
                .to(this.$refs.mask, {duration: 3, scale: '6', opacity: '0'}, '3');
            this.timeline.progress(0.0001);
            this.timeline.pause();
        },
        createAnimation() {
            this.createTimeline();
            if (document.documentElement.clientWidth < 768) {
                this.createScroll('top-middle', 'top-top');
            } else {
                this.createScroll();
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';

.container {
    height: 400vh;
    position: relative;
    overflow: hidden;

    @media (--viewport-tablet) {
        height: fit-content;
    }
}

.animated-scroll {
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    min-height: 100vh;
    width: 100%;
    @media (--viewport-tablet) {
        position: static !important;
    }

    &.fixed {
        position: fixed;
        top: 0;
        left: 0;
    }

    &.bottom {
        bottom: 0;
        top: auto;
    }
}

.masked-text {
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    //padding: 40px 0;
    min-height: 100vh;
    @media (--viewport-laptop) {
        padding: 0;
    }

    .content {
        &_aim {
            background-color: #fff;
            color: #000;
            &.blur {
                filter: blur(2px);
            }
        }
    }
    .masked-text__mask-wrp {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
    }
    &__mask {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: fit-content;
        height: fit-content;
        pointer-events: none;
        z-index: 1;
    }
}

.mask-aim {
    padding: 300vh 300vw;
    width: calc(600vw + 30vh + 30vw);
    img {
        width: calc(30vh + 30vw);
    }
}
.bg-holder {
    position: absolute;
    background-color: #f00;
    &.top {
        left: 0;
        top: 0;
        width: calc(100% + 1px);
        height: calc(300vh + 1px);
    }
    &.right {
        right: 0;
        top: 0;
        height: calc(100% + 1px);
        width: calc(300vw + 1px);
    }
    &.bottom {
        bottom: 0;
        width: calc(100% + 1px);
        left: 0;
        height: calc(300vh + 1px);
    }
    &.left {
        left: 0;
        top: 0;
        height: calc(100% + 1px);
        width: calc(300vw + 1px);
    }
}
</style>
